import {
  Box,
  IconButton,
  Stack,
  Button,
  Typography,
  Container,
  Toolbar,
  CardMedia,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Drawer,
} from "@mui/material";
import { AppBar } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, Outlet, useNavigate } from "react-router-dom";
import { Update } from "../App";
import gym from "../assets/icons/gym.png";
import gym1 from "../assets/icons/gym1.png";

import { Link as RouterLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import SearchIcon from "@mui/icons-material/Search";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import LineStyleIcon from "@mui/icons-material/LineStyle";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import MonitorWeightIcon from "@mui/icons-material/MonitorWeight";
import HomeIcon from "@mui/icons-material/Home";
const Gym = () => {
  const navigate = useNavigate();
  const { setDisplayAppBar,mode } = useContext(Update);
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/gym") {
      setDisplayAppBar("none");
    }
    if (location.pathname !== "/gym/gymexercise") {
      document.cookie = "StartTime=0;";
    }
  }, []);

  const [open, setOpen] = useState(false);
  function handleDrawerClick() {
    setOpen(false);
  }
  const handleOpenNavMenu = () => {
    setOpen(true);
  };

  return (
    <>
      <div style={{ backgroundColor: "#16181D", height: "50px" }}></div>
      <AppBar position="static" sx={{ backgroundColor: "rgb(32, 35, 42)" }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <CardMedia
              src={mode==="light"?(gym):(gym1)} 
              component="img"
              sx={{
                display: { xs: "none", md: "flex" },
                width: "20px",
                height: "20px",
              }}
            />
            <Typography
              variant="h6"
              noWrap
              onClick={() => navigate("/gym/homegym")}
              sx={{
                cursor: "pointer",
                mr: 2,
                ml: "10px",
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".1rem",
                color: mode==="light"?("red" ): ('blue'),
                textDecoration: "none",
              }}
            >
              Gym
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Drawer open={open} onClose={handleDrawerClick}>
                <List>
                  <ListItem
                    onClick={() => {
                      navigate("/gym/traninggym");
                      setOpen(false);
                    }}
                  >
                    <ListItemIcon>
                      <IconButton edge="start" color="inherit">
                        <DirectionsRunIcon />
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText
                      sx={{
                        cursor: "pointer",
                        color: "grey",
                      }}
                      primary="Training"
                    />
                  </ListItem>
                  <ListItem
                    onClick={() => {
                      navigate("/gym/discovergym");
                      setOpen(false);
                    }}
                  >
                    <ListItemIcon>
                      <IconButton edge="start" color="inherit">
                        <SearchIcon />
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText
                      sx={{
                        cursor: "pointer",
                        color: "grey",
                      }}
                      primary="Discover"
                    />
                  </ListItem>

                  <ListItem
                    onClick={() => {
                      navigate("/gym/customize");
                      setOpen(false);
                    }}
                  >
                    <ListItemIcon>
                      <IconButton edge="start" color="inherit">
                        <LocalFireDepartmentIcon />
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText
                      sx={{
                        cursor: "pointer",
                        color: "grey",
                      }}
                      primary="Customize"
                    />
                  </ListItem>
                  <ListItem
                    onClick={() => {
                      navigate("/gym/dashboardgym");
                      setOpen(false);
                    }}
                  >
                    <ListItemIcon>
                      <IconButton edge="start" color="inherit">
                        <LineStyleIcon />
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText
                      sx={{
                        cursor: "pointer",
                        color: "grey",
                      }}
                      primary="Dashboard"
                    />
                  </ListItem>
                  <ListItem
                    onClick={() => {
                      navigate("/gym/music");
                      setOpen(false);
                    }}
                  >
                    <ListItemIcon>
                      <IconButton edge="start" color="inherit">
                        <MusicNoteIcon />
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText
                      sx={{
                        cursor: "pointer",
                        color: "grey",
                      }}
                      primary="Music"
                    />
                  </ListItem>
                  <ListItem
                    onClick={() => {
                      navigate("/gym/gymdiet");
                      setOpen(false);
                    }}
                  >
                    <ListItemIcon>
                      <IconButton edge="start" color="inherit">
                        <MonitorWeightIcon />
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText
                      sx={{
                        cursor: "pointer",
                        color: "grey",
                      }}
                      primary="Diet"
                    />
                  </ListItem>
                </List>
              </Drawer>
            </Box>
            <CardMedia
              src={mode==="light"?(gym):(gym1)} 

              component="img"
              sx={{
                display: { xs: "flex", md: "none" },
                width: "20px",
                height: "20px",
              }}
            />
            <Typography
              variant="h5"
              noWrap
              onClick={() => navigate("/gym/homegym")}
              sx={{
                cursor: "pointer",
                ml: "10px",
                mr: 2,
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".2rem",
                color: mode==="light"?("red" ): ('blue'),
                textDecoration: "none",
              }}
            >
              Gym
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              <Stack direction="row" spacing={4}>
                <Button
                  sx={{ fontSize: {md:"1.7vw",lg:"1vw"},color:mode==="light"?("red" ): ('blue') }}
                  onClick={() => {
                    navigate("/gym/traninggym");
                  }}
                >
                  Training
                </Button>
                <Button
                  sx={{ fontSize: {md:"1.7vw",lg:"1vw"},color:mode==="light"?("red" ): ('blue')  }}
                  
                  onClick={() => {
                    navigate("/gym/discovergym");
                  }}
                >
                  Discover
                </Button>
                <Button
                  sx={{ fontSize: {md:"1.7vw",lg:"1vw"},color:mode==="light"?("red" ): ('blue')  }}
                  
                  onClick={() => {
                    navigate("/gym/customize");
                  }}
                >
                  Customize
                </Button>
                <Button
                  sx={{ fontSize: {md:"1.7vw",lg:"1vw"},color:mode==="light"?("red" ): ('blue')  }}
                  
                  onClick={() => {
                    navigate("/gym/dashboardgym");
                  }}
                >
                  Dashboard
                </Button>
                <Button
                  sx={{ fontSize: {md:"1.7vw",lg:"1vw"},color:mode==="light"?("red" ): ('blue')  }}
                  
                  onClick={() => {
                    navigate("/gym/music");
                  }}
                >
                  Music
                </Button>
                <Button
                  sx={{ fontSize: {md:"1.7vw",lg:"1vw"},color:mode==="light"?("red" ): ('blue')  }}
                  
                  onClick={() => {
                    navigate("/gym/gymdiet");
                  }}
                >
                  Diet
                </Button>
              </Stack>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Outlet />
      <Box style={{ position: "fixed", bottom: "20px", left: "20px" }}>
        <Button
          onClick={() => {
            navigate("/");
          }}
          variant="contained"
          sx={{ backgroundColor: "transparent" }}
        >
          <HomeIcon  color="error"/>
        </Button>
      </Box>
    </>
  );
};

export default Gym;
